const isObject = (value: any) => {
  return value === Object(value);
};

export default isObject;
